__turbopack_context__.v({
  "preventAnchor": "SidebarNav-module__5or2Gq__preventAnchor",
  "scroll": "SidebarNav-module__5or2Gq__scroll",
});
